import Loading from "./Loading";

const Renderer = (props: any) => {
  const model = props.model;

  if (!model) {
    return <Loading message="Loading Component..." />;
  }

  if (!model.isValid()) {
    return <div>{model.getError()}</div>;
  }

  return model.getComponents();
};

export default Renderer;
